(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-globals"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {

  // Use a MutationObserver to wait for ReCharge to inject its nav element
  const observer = new MutationObserver(() => {
    const el = document.querySelector('.recharge-navigation-overview');
    if (!el) return;

    // Stop watching once we find it
    observer.disconnect();

    // Don't add the link twice if something re-triggers this
    if (document.querySelector('.recharge-brand-perks')) return;

    // Clone the parent <li> (or wrapper) cleanly
    const clone = el.parentElement.cloneNode(true);
    const innerEl = clone.querySelector('.recharge-navigation-overview');

    // Fix classes
    innerEl.classList.remove('active', 'recharge-navigation-overview');
    innerEl.classList.add('recharge-brand-perks');

    // Fix attributes
    innerEl.href = '/pages/parasol-perks';
    innerEl.setAttribute('aria-label', 'Brand Perks');
    innerEl.removeAttribute('aria-current');
    innerEl.removeAttribute('data-testid');
    innerEl.removeAttribute('data-active');
    innerEl.removeAttribute('data-discover');

    // Fix label text
    innerEl.querySelector('.recharge-heading-h2').textContent = 'Brand Perks';

    // Insert before the original parent
    el.parentElement.insertAdjacentElement('beforebegin', clone);
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
  } catch(e) { console.error(e); }
})();

})();
